/**
 * PdfDemoPanel — C079 PDF 처리 데모 (queue #646 §R646-2 항목8)
 * 고정 표 스펙(제목+컬럼+행) → PDF 다운로드. C082(포맷 라우팅 Facade)와 구분 —
 * 이 패널은 PdfGenerator 직접 표 생성. 순수.
 */
import { useTranslation } from 'react-i18next';
import { usePdfGenerate } from '../../hooks/usePdfDemo';
import { cardStyle, sectionTitleStyle, subtitleStyle, monoStyle, primaryButtonStyle, DemoErrorState, DemoEmptyHint } from './demoShared';

// queue #653 §R653-3: title/columns 는 BE 페이로드이자 화면 요약 라인에 그대로 노출되므로
// i18n 처리 대상(고정 데모 인물명 rows 는 요약 라인에 노출되지 않아 그대로 유지 — PDF 본문에만 사용).
const DEMO_TABLE_ROWS = [
  ['김민준', 'minjun.kim@skax.co.kr', '플랫폼팀'],
  ['이서연', 'seoyeon.lee@skax.co.kr', 'AI Platform'],
  ['박도윤', 'doyoon.park@skax.co.kr', '인프라팀'],
];

export function PdfDemoPanel() {
  const { t } = useTranslation();
  const generateMutation = usePdfGenerate();
  const DEMO_TABLE = {
    title: t('showcase.demo.pdf.demoTableTitle'),
    columns: [t('showcase.demo.pdf.demoColumnName'), t('showcase.demo.pdf.demoColumnEmail'), t('showcase.demo.pdf.demoColumnDept')],
    rows: DEMO_TABLE_ROWS,
  };

  function handleGenerate() {
    generateMutation.mutate(DEMO_TABLE, {
      onSuccess: (blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'showcase-pdf-demo.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      },
    });
  }

  return (
    <section aria-labelledby="pdf-panel-title">
      <h2 id="pdf-panel-title" style={sectionTitleStyle}>{t('showcase.demo.pdf.title')}</h2>
      <p style={subtitleStyle}>{t('showcase.demo.pdf.subtitle')}</p>

      <div style={cardStyle}>
        <p style={{ ...monoStyle, fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', marginBottom: 'var(--spacing-4)' }}>
          {DEMO_TABLE.title} ({DEMO_TABLE.columns.join(' · ')}) — {DEMO_TABLE.rows.length} rows
        </p>

        <button
          type="button"
          onClick={handleGenerate}
          disabled={generateMutation.isPending}
          aria-busy={generateMutation.isPending}
          style={{ ...primaryButtonStyle, opacity: generateMutation.isPending ? 0.6 : 1 }}
        >
          {generateMutation.isPending ? t('showcase.demo.pdf.generating') : t('showcase.demo.pdf.generateButton')}
        </button>

        <div style={{ marginTop: 'var(--spacing-4)' }}>
          {generateMutation.isError && (
            <DemoErrorState title={t('showcase.demo.common.callFailed')} error={generateMutation.error} />
          )}
          {!generateMutation.isError && !generateMutation.isSuccess && <DemoEmptyHint text={t('showcase.demo.pdf.empty')} />}
          {generateMutation.isSuccess && (
            <p role="status" style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-status-success)' }}>
              {t('showcase.demo.pdf.downloaded')}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
